$.module('MM.user.confirmAgreement', function () {
  var ACTIONS = {};

  var tmpl =
    '\
        <div class="confirm-agreement">\
            <p>为了您能正常使用么么平台账号，请仔细阅读并确认此协议。</p>\
            <p><a href="/notice/10497" target="_blank" class="text-primary text-rule">《主播管理协议》</a></p>\
            <p><span class="agree"><i class="input-check"></i> 我已阅读并同意</span></p>\
            <p><a href="javascript:void(0);" class="btn btn-block btn-danger btn-lg disabled">确认</a></p>\
        </div>\
    ';

  function _init() {
    if (
      (MM.user.isBroker() || MM.user.isAnchor()) &&
      location.pathname.indexOf('notice') < 0 &&
      !window['inPcClient']
    ) {
      request.get({
        url: 'api/v1/common/enter/key?key=CCA',
        urlType: 'cryolite',
        success: function (res) {
          if (!res.data) {
            MM.ui.popup.show({
              id: 'confirmAgreement',
              title: '重要提示',
              center: true,
              disableMsk: true,
              showCloseBtn: false,
              content: tmpl,
              appendCallback: function ($popup) {
                var isViewedRule = false;
                $popup
                  .delegate('.agree', 'click', function () {
                    if (!isViewedRule) {
                      MM.ui.messager.warn('请先点击查看《么么直播管理规则》');
                      return;
                    }
                    $(this).find('.input-check').toggleClass('on');
                    $popup.find('.btn').toggleClass('disabled');
                  })
                  .delegate('.btn', 'click', function () {
                    if ($(this).hasClass('disabled')) {
                      return;
                    }
                    submitConfirm();
                  })
                  .delegate('.text-rule', 'click', function () {
                    isViewedRule = true;
                  });
              },
            });
          }
        },
      });
    }
  }

  function submitConfirm() {
    request.post({
      url: '/api/v1/common/enter/key?key=CCA',
      urlType: 'cryolite',
      success: function () {
        MM.ui.popup.hide();
      },
    });
  }

  return {
    init: _init,
  };
});
